<template>
    <b-card
            title="مدیریت پروژه ها"
    >
        <b-row>
            <b-col
                    class="table-size"
            >
                <div class="custom-search">
                    <b-row>
                        <div class="filter-row">
                            <b-button
                                    class="mb-1 mr-auto ml-1"
                                    variant="primary"
                                    :to="{ name: 'addproject'}"
                            >
                                جدید
                            </b-button>
                            <b-col md="2">
                                <b-form-group
                                        label="عنوان"
                                        label-for="Title"
                                >
                                    <b-form-input
                                            v-model="filterOptions.Title"
                                            @keyup.enter="update(1)"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <b-form-group
                                        label="دسته بندی"
                                        label-for="Type">
                                    <project-category
                                            v-model="filterOptions.ProjectCategoryId"
                                            :multiple="false"
                                            :clearable="true"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-col md="2">
                                <b-form-group>
                                    <label>وضعیت</label>
                                    <v-select
                                            v-model="filterOptions.Visibility"
                                            :options="enums('IsActive')"
                                            dir="rtl"
                                            label="text"
                                            :reduce="x => x.value"
                                    />
                                </b-form-group>
                            </b-col>
                            <b-button
                                    v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                                    class="mb-1 mr-1"
                                    variant="warning"
                                    @click="update(1)"
                            >فیلتر
                            </b-button>
                        </div>
                    </b-row>
                </div>

                <b-table
                        bordered
                        hover
                        striped
                        :items="items"
                        :fields="fields"
                        class="mt-1 mb-2 position-relative"
                        responsive
                        :busy="loading"
                        :no-local-sorting="true"
                        :sort-by="filterOptions.SortBy"
                        :sort-desc="filterOptions.IsDesc"
                        @sort-changed="sortChange"
                >
                    <template #cell(Id)="data">
                        <b-link
                                :to="{ name: 'updateproject', params: { id: data.value }}"
                                class="font-weight-bold"
                        >
                            #{{ data.value }}
                        </b-link>
                    </template>

                    <template #cell(Title)="data">
                        <div class="align-items-center d-flex">
                            <div>
                                <b-avatar
                                        class="mr-1"
                                        :src="data.item.Image"
                                />
                            </div>
                            <div>
                                {{ data.value }}
                            </div>
                        </div>
                    </template>

                    <template #cell(ProjectCategory)="data">
              <b-badge
                      style="line-height: unset; margin: 2px;"
                      variant="info"
              >
                {{ data.value.Title  }}
              </b-badge>
                    </template>

                    <template #cell(CreatedAt)="data">
            <span class="text-nowrap">
              {{ data.value | date }}
            </span>
                    </template>

                    <template #cell(Visit)="data">
                        {{ data.value | price }}
                    </template>

                    <template #cell(Visibility)="data">
                        <b-badge
                                :variant="data.item.Visibility ? 'success' : 'warning'"
                        >
                            {{  data.item.Visibility ? 'فعال' : 'غیر فعال' }}
                        </b-badge>
                    </template>

                    <template #cell(actions)="data">

                        <div
                                class="text-nowrap"
                        >
                            <b-link
                                    :href="'https://decopuzzle.ir/project/'+ data.item.Id+ '/'+data.item.Title.replace(' ', '-')"
                                    target='_blank'
                            >
                                <feather-icon
                                        icon="NavigationIcon"
                                        size="16"
                                />
                            </b-link>

                            <b-link :to="{ name: 'updateproject', params: { id: data.item.Id }}">
                                <feather-icon
                                        :id="`invoice-row-${data.item.Id}-send-icon`"
                                        icon="EditIcon"
                                        size="16"
                                        class="ml-1"
                                />
                            </b-link>

                            <feather-icon

                                    icon="TrashIcon"
                                    size="16"
                                    class="ml-1"
                                    @click="remove(data.item.Id)"
                            />
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                    <template #table-busy>
                        <div
                                class="text-center my-2"
                        >
                            <b-spinner
                                    variant="primary"
                                    class="align-middle"
                            />
                            <strong class="ml-1">در حال دریافت اطلاعات ...</strong>
                        </div>
                    </template>

                </b-table>

                <z-pagination
                        :page="filterOptions.Page"
                        :total-rows="totalRows"
                        :loading="loading"
                        @change="update"
                />

            </b-col>

        </b-row>
    </b-card>
</template>

<script>

import ProjectCategory from '@/tools/projectcategory.vue'

export default {
    name: 'Project',
    components: {
        ProjectCategory,
    },
    data() {
        return {
            totalRows: 1000 * 1000,
            loading: false,
            filterOptions: {
                Title: null,
                Page: 1,
                SortBy: 'Id',
                IsDesc: true,
                ProjectCategoryId: null,
                Visibility: true,
                Type: 0
            },
            fields: [
                {
                    key: 'Id',
                    label: '#',
                    thClass: 'col-width-50',
                },
                {
                    key: 'Title',
                    label: 'عنوان',
                },
                {
                    key: 'ProjectCategory',
                    label: 'دسته بندی',
                },
                {
                    key: 'CreatedAt',
                    label: 'تاریخ',
                },
                {
                    key: 'Visit',
                    label: 'بازدید',
                },
                {
                    key: 'Visibility',
                    label: 'وضعیت',
                },
                {
                    key: 'actions',
                    label: '',
                    thClass: 'col-width-50',
                },
            ],
            items: [],
        }
    },
    computed: {
    },
    created() {
        if (this.$store.state.zirehState.listFilter[this.$options.name]) {
            this.filterOptions = this.$store.state.zirehState.listFilter[this.$options.name]
        }
        this.update()
    },
    methods: {
        sortChange(e) {
            if (e.sortBy) {
                this.filterOptions.SortBy = e.sortBy
                this.filterOptions.IsDesc = e.sortDesc
                this.update(1)
            }
        },
        update(pageNumber) {
            this.loading = true

            this.filterOptions.Page = pageNumber || this.filterOptions.Page

            this.$store.commit('zirehState/setListFilter', { key: this.$options.name, value: this.filterOptions })

            this.$http.post(
                this.$api.project.getlist, this.filterOptions,
            )
                .then(res => {
                    this.totalRows = res.totalRow
                    this.items = res.data
                })
                .finally(() => {
                    this.loading = false
                })
        },
        remove(id) {
            this.removeRow(this.$api.project.remove, 'Id', id)
        },
    },
}
</script>
